import { useParams, useNavigate, Link } from 'react-router-dom';
import { toast } from 'sonner';
import { useBedarf, useUpdateBedarf } from '../../api/bedarfe';
import { BedarfeForm } from '../../components/bedarfe';
import { CreateBedarfDto } from '../../types/bedarf';

export function BedarfEditPage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { data, isLoading, error } = useBedarf(id!);
  const updateMutation = useUpdateBedarf();

  const handleSubmit = async (formData: CreateBedarfDto) => {
    try {
      await updateMutation.mutateAsync({ id: id!, data: formData });
      toast.success('Bedarf erfolgreich aktualisiert');
      navigate(`/bedarfe/${id}`);
    } catch (error) {
      console.error('Failed to update bedarf:', error);
      toast.error('Fehler beim Aktualisieren des Bedarfs');
    }
  };

  const handleCancel = () => {
    navigate(`/bedarfe/${id}`);
  };

  if (isLoading) {
    return (
      <div className="text-center py-12">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600 mx-auto"></div>
        <p className="mt-2 text-sm text-gray-500">Laden...</p>
      </div>
    );
  }

  if (error || !data?.data) {
    return (
      <div className="text-center py-12">
        <p className="text-red-600">Bedarf nicht gefunden</p>
        <Link to="/bedarfe" className="mt-4 inline-block text-primary-600 hover:text-primary-500">
          Zurück zur Übersicht
        </Link>
      </div>
    );
  }

  const bedarf = data.data;

  return (
    <div>
      {/* Header */}
      <div className="mb-6">
        <nav className="flex mb-2" aria-label="Breadcrumb">
          <ol className="flex items-center space-x-2 text-sm text-gray-500">
            <li><Link to="/bedarfe" className="hover:text-gray-700">Bedarfe</Link></li>
            <li>/</li>
            <li><Link to={`/bedarfe/${id}`} className="hover:text-gray-700">{bedarf.childFirstName} {bedarf.childLastName}</Link></li>
            <li>/</li>
            <li className="text-gray-900">Bearbeiten</li>
          </ol>
        </nav>
        <h1 className="text-2xl font-bold text-gray-900">
          Bedarf bearbeiten: {bedarf.childFirstName} {bedarf.childLastName}
        </h1>
      </div>

      <BedarfeForm
        initialData={bedarf}
        onSubmit={handleSubmit}
        onCancel={handleCancel}
        isLoading={updateMutation.isPending}
      />
    </div>
  );
}
